<template>
  <v-breadcrumbs :class="$style.breadcrumbs"
                 :items="items" />
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" module>
@import "@/styles/variables.scss";

  .breadcrumbs {
    padding-bottom: 6px;

    li {
      // Overriding Vuetify style
      color: $breadcrumbs-color !important;

      a {
        color: $breadcrumbs-color;
        font-weight: 700;
      }

      &::before {
        content: none;
      }
    }
  }
</style>
